angular.module('pe4h').controller('ClientProposalList', function($scope, $http, $q, configuration, Upload, $uibModal, $state) {

  var setHired = function(){
    for (i in $scope.proposalList){
      if($scope.proposalList[i].UserId == $scope.project.HiredUserId){
        $scope.setHiredName($scope.proposalList[i].User.FullName);
        $scope.setReviewed($scope.proposalList[i].ReviewScore);
        break;
      }
    }
  }

  $http({
    url: configuration.webApi.projects.proposals({
      id: $scope.project.Id
    }),
    method: "GET",
    data: {},
  }).success(function(res, status, headers, config) {
    $scope.proposalList = res;
    if($scope.project.HiredUserId){
      setHired();
    }
    console.log($scope.proposalList);
  }).error(function(error, status, headers, config) {
    $scope.alertErrorFromServer(error);
  });

  $scope.review = {};

  $scope.setMousePosition = function(pos){
    $scope.review.mousePosition = pos;
  }

  $scope.hire = function(id, fullName) {
    var modalHire = $uibModal.open({
      templateUrl: 'modal-hire.html',
      size: 'sm',
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", function($scope, $uibModalInstance, $q, $state) {
        $scope.name = fullName;
        $scope.agreed = function() {
          $http({
            url: configuration.webApi.proposals.id_hire({
              id: id
            }),
            method: "POST",
            data: {},
          }).success(function(res, status, headers, config) {
            $state.reload();
          }).error(function(error, status, headers, config) {
            $scope.alertErrorFromServer(error);
          });
          $uibModalInstance.close();
        }
      }]
    });
    modalHire.closed.then(function(data) {
      console.log(data);
    });
  }

  $scope.setStars = function(cant) {
    $scope.review.stars = cant;
  };

  $scope.isInvalid = function() {
    return $scope.review.stars == undefined;
  };

  $scope.postReview = function(id, fullName) {
    $http({
      url: configuration.webApi.proposals.id_review({
        id: id
      }),
      method: "Post",
      data: {
        "Score": $scope.review.stars,
        "Review": $scope.review.message
      },
    }).success(function(res, status, headers, config) {
      //console.log(res);


      var modalReview = $uibModal.open({
        templateUrl: 'modal-thanks.html',
        size: 'sm',
        scope: $scope,
        controller: ["$scope", "$uibModalInstance", "$q", function($scope, $uibModalInstance, $q) {
          $scope.name = fullName;

        }]
      });
      modalReview.closed.then(function(data) {
        $state.reload();
      });


    }).error(function(error, status, headers, config) {
      $scope.alertErrorFromServer(error);
    });

  }


});
